import { put, takeLatest, select, cancel } from 'redux-saga/effects';
import { merge } from 'lodash';

import {
  paginatedConsts as usersJoinRequests,
  paginatedActions,
} from '../usersJoinRequests';
import {
  usersJoinRequestsListSelector,
  usersJoinRequestsCounterSelector,
  usersJoinRequestsPaginationSelector,
} from '../selectors/usersJoinRequests';

function* usersJoinRequestsPaginationWorker() {
  const limit = 10;

  const paginationOptions = yield select(usersJoinRequestsPaginationSelector);
  const requestsTotal = yield select(usersJoinRequestsCounterSelector);
  const existingRequests = yield select(usersJoinRequestsListSelector);

  if (requestsTotal <= existingRequests.length) {
    yield cancel();
  }

  const params = merge({}, paginationOptions, {
    offset: existingRequests.length,
    limit,
  });

  yield put(paginatedActions.updatePaginationParameters(params));

  yield put({
    type: usersJoinRequests.SEND,
    payload: params,
  });
}

export default function* usersJoinRequestsPaginationSaga() {
  yield takeLatest(
    usersJoinRequests.LOAD_NEXT_REQUESTS,
    usersJoinRequestsPaginationWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/communities/sagas/usersJoinRequestsPagination.js